import { ToastId } from "@chakra-ui/react";
import { MessageThreadType } from "gql/graphql";
import React, {
  createContext,
  ReactNode,
  useContext,
  useMemo,
  useState,
} from "react";

interface IContextProps {
  highlightMessage?: IHighlightMessage;
  setHighlightMessage: (hightlightMessage?: IHighlightMessage) => void;
  toastId?: ToastId;
  setToastId: (toastId?: ToastId) => void;
  selectedMessageThreadType?: MessageThreadType;
  setSelectedMessageThreadType: (
    selectedMessageThreadType?: MessageThreadType,
  ) => void;
}

interface IHighlightMessage {
  timestamp?: string;
  messageId?: string;
}

const GlobalStateContext = createContext<IContextProps>({
  setHighlightMessage: () => {},
  setToastId: () => {},
  setSelectedMessageThreadType: () => {},
});

export interface IProviderProps {
  children?: ReactNode;
}

export const GlobalStateProvider = ({ children }: IProviderProps) => {
  const [highlightMessage, setHighlightMessage] = useState<IHighlightMessage>();
  const [toastId, setToastId] = useState<ToastId>();
  const [selectedMessageThreadType, setSelectedMessageThreadType] =
    useState<MessageThreadType>();

  const value = useMemo<IContextProps>(
    () => ({
      highlightMessage,
      setHighlightMessage,
      toastId,
      setToastId,
      selectedMessageThreadType,
      setSelectedMessageThreadType,
    }),
    [highlightMessage, selectedMessageThreadType, toastId],
  );

  return (
    <GlobalStateContext.Provider value={value}>
      {children}
    </GlobalStateContext.Provider>
  );
};

export const useGlobalState = () => useContext(GlobalStateContext);
